import React from "react";

const ScrapPrices = () => {
  const scrapData = [
    {
      name: "Copper Millberry Scrap",
      price: "₹720 / KG",
      image:
        "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800",
    },
    {
      name: "Premium Aluminium Wire Scrap",
      price: "₹185 / KG",
      image:
        "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800",
    },
    {
      name: "Iron Punching Scrap",
      price: "₹42 / KG",
      image:
        "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800",
    },
    {
      name: "Copper Wire Scrap",
      price: "₹695 / KG",
      image:
        "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800",
    },
  ];

  return (
    <>
     <style>{`
.price-section{
  padding:80px 5%;
  background:linear-gradient(135deg,#f8fafc,#eef4ff);
  overflow:hidden;
}

/* =========================
   HEADING
========================= */

.price-title{
  text-align:center;
  font-size:42px;
  font-weight:700;
  color:#0B2E7A;
  margin-bottom:12px;
  animation:fadeDown 1s ease;
}

.price-line{
  width:100px;
  height:4px;
  background:#FFD400;
  margin:0 auto 50px;
  border-radius:20px;
  transition:.4s;
}

.price-section:hover .price-line{
  width:180px;
}

/* =========================
   CAROUSEL
========================= */

.carousel-wrapper{
  overflow:hidden;
  position:relative;
  width:100%;
}

.carousel-track{
  display:flex;
  gap:25px;
  width:max-content;
  animation:scroll 25s linear infinite;
  padding:10px 0;
}

.carousel-track:hover{
  animation-play-state:paused;
}

/* =========================
   CARD
========================= */

.price-card{
  min-width:300px;
  background:#fff;
  border-radius:20px;
  overflow:hidden;
  box-shadow:0 10px 25px rgba(0,0,0,.08);
  transition:.4s ease;
  cursor:pointer;
}

.price-card:hover{
  transform:translateY(-12px) scale(1.03);
  box-shadow:
    0 25px 45px rgba(11,46,122,.18),
    0 10px 20px rgba(255,212,0,.15);
}

/* =========================
   IMAGE
========================= */

.price-card img{
  width:100%;
  height:220px;
  object-fit:cover;
  transition:.6s;
}

.price-card:hover img{
  transform:scale(1.12);
}

/* =========================
   CONTENT
========================= */

.price-content{
  padding:22px;
  text-align:center;
}

.price-content h3{
  color:#0B2E7A;
  font-size:20px;
  font-weight:700;
  margin-bottom:15px;
  transition:.3s;
  line-height:1.4;
}

.price-card:hover h3{
  color:#FFD400;
  text-shadow:0 4px 12px rgba(255,212,0,.4);
}

.price{
  font-size:30px;
  font-weight:800;
  color:#0B2E7A;
  margin-bottom:12px;
  transition:.3s;
}

.price-card:hover .price{
  color:#FFD400;
  transform:scale(1.08);
  text-shadow:0 4px 15px rgba(255,212,0,.5);
}

.live{
  color:#28a745;
  font-weight:600;
  transition:.3s;
}

.price-card:hover .live{
  letter-spacing:1px;
  transform:translateY(-2px);
}

/* =========================
   ANIMATIONS
========================= */

@keyframes scroll{

  0%{
    transform:translateX(0);
  }

  100%{
    transform:translateX(-50%);
  }

}

@keyframes fadeDown{

  from{
    opacity:0;
    transform:translateY(-30px);
  }

  to{
    opacity:1;
    transform:translateY(0);
  }

}

/* =========================
   TABLET
========================= */

@media (max-width:992px){

  .price-section{
    padding:70px 20px;
  }

  .price-title{
    font-size:36px;
  }

  .price-line{
    margin-bottom:40px;
  }

  .price-card{
    min-width:280px;
  }

  .price-card img{
    height:210px;
  }

  .price-content{
    padding:20px;
  }

  .price-content h3{
    font-size:19px;
  }

  .price{
    font-size:28px;
  }

}

/* =========================
   MOBILE
========================= */

@media (max-width:768px){

  .price-section{
    padding:55px 15px;
  }

  .price-title{
    font-size:30px;
    line-height:1.3;
  }

  .price-line{
    width:70px;
    margin-bottom:30px;
  }

  .price-section:hover .price-line{
    width:120px;
  }

  .carousel-track{
    gap:18px;
    animation-duration:18s;
  }

  .price-card{
    min-width:260px;
  }

  .price-card img{
    height:190px;
  }

  .price-content{
    padding:18px;
  }

  .price-content h3{
    font-size:18px;
  }

  .price{
    font-size:24px;
  }

  .live{
    font-size:14px;
  }

}

/* =========================
   SMALL MOBILE
========================= */

@media (max-width:480px){

  .price-section{
    padding:45px 12px;
  }

  .price-title{
    font-size:26px;
  }

  .price-card{
    min-width:230px;
  }

  .price-card img{
    height:170px;
  }

  .price-content{
    padding:16px;
  }

  .price-content h3{
    font-size:17px;
  }

  .price{
    font-size:22px;
  }

  .live{
    font-size:13px;
  }

  .carousel-track{
    gap:15px;
    animation-duration:15s;
  }

}
`}</style>

      <section className="price-section" style={{marginTop:'-15px'}}>
        <h2 className="price-title">Current Scrap Prices</h2>

        <div className="price-line"></div>

        <div className="carousel-wrapper">
          <div className="carousel-track">
            {[...scrapData, ...scrapData].map((item, index) => (
              <div className="price-card" key={index}>
                <img src={item.image} alt={item.name} />

                <div className="price-content">
                  <h3>{item.name}</h3>

                  <div className="price">{item.price}</div>

                  <div className="live">
                    ▲ Live Market Rate
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ScrapPrices;